// Context of the signup / login redesign carried across its steps (signup -> verify ->
// plans -> checkout) and reused when a no-plan user opens the plan picker later.
// Persisted in sessionStorage so a refresh on the verify page keeps the pending signup.
// Deliberately NOT cleared by clearStore (the auth pages call it on mount); use signup/reset.
const STORAGE_KEY = 'pop.signup.v1'

const defaults = () => ({
  entry: 'direct', // direct | pricing | affiliate | campaign
  email: '',
  provider: 'password', // password | google | apple
  pendingToken: '',
  resendAvailableAt: 0,
  lockedUntil: 0,
  plan: null, // { id, title, code, interval, price }
  promoCode: '',
  affiliateCode: '',
  coupon: null, // validated coupon of promoCode, for display
  utm: {},
  redirect: '',
  firstRun: null, // { url, keyword }
  checkoutSessionId: '', // Stripe Checkout session being paid
  social: null, // { profile, socialToken, intent, isSubAccount } (M5)
  linkToken: '',
  loginChallenge: null, // { pendingLoginToken, email, redirect, resendAvailableAt } (M4)
})

function read () {
  try {
    const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}')
    return { ...defaults(), ...(saved && typeof saved === 'object' ? saved : {}) }
  } catch (e) {
    return defaults()
  }
}

function persist (state) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  } catch (e) {
    // private mode / blocked storage: the flow still works within the page
  }
}

export default {
  namespaced: true,
  state: read,
  getters: {
    hasPendingSignup: (state) => Boolean(state.pendingToken),
    promoOrAffiliateCode: (state) => state.promoCode || state.affiliateCode || '',
    hasSelectedPlan: (state) => Boolean(state.plan && state.plan.code),
  },
  mutations: {
    patch (state, payload) {
      Object.assign(state, payload || {})
      persist(state)
    },
    setPlan (state, plan) {
      state.plan = plan || null
      persist(state)
    },
    setCoupon (state, coupon) {
      state.coupon = coupon || null
      persist(state)
    },
    clearPending (state) {
      state.pendingToken = ''
      state.resendAvailableAt = 0
      state.lockedUntil = 0
      persist(state)
    },
    reset (state) {
      Object.assign(state, defaults())
      try {
        sessionStorage.removeItem(STORAGE_KEY)
      } catch (e) {
        // ignore
      }
    },
  },
}
